var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginBgTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 839,
    height: 126,
    viewBox: "0 0 839 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.63624 37C-11.4521 -37.5 40.6362 -44.1667 63.1362 -65H713.636C756.136 -50.1667 840.536 -9 838.136 37C835.136 94.5 733.136 125.5 637.136 125.5C541.136 125.5 474.499 75 337.136 75C212.499 75 150.136 131.5 96.6359 125.5C43.1359 119.5 11.6361 76.5 3.63624 37Z",
    fill: "url(#paint0_linear_691_353)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_691_353",
    x1: 110.044,
    y1: -195.492,
    x2: 696.773,
    y2: 295.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0395,
    stopColor: "#240B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#3D1E59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9428,
    stopColor: "#BC14FE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBgTop);
export default __webpack_public_path__ + "static/media/login-bg-top.96a50655f297057e56460fc4a373adad.svg";
export { ForwardRef as ReactComponent };